<template>
    <div class="row">
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-else class="col-lg-12 mb-4">
            <div class="box">
                <ValidationObserver  ref="form">
                    <div class="box-offset">
                        <div class="box-ttl-wrap">
                            <h4>Add Preconfigured Responses</h4>
                        </div>
                        <div class="form mt-3">
                            <div class="row mb-3">

                                <ValidationProvider
                                    name="Subject"
                                    rules="required|min:2"
                                    v-slot="{errors}"
                                    class="col-md-12"
                                >
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Subject</label>
                                        <input type="text" class="form-control" v-model="response.subject">
                                        <FormError :error="errors[0]" name="Subject"></FormError>
                                    </div>
                                </ValidationProvider>

                                <div class="col-md-6">

                                </div>
                                <ValidationProvider
                                    name="Message"
                                    rules="required|min:2"
                                    v-slot="{errors}"
                                    class="col-md-12"
                                >
                                    <div class="form-group form-group-1">
                                        <label for="" class="form-label">Email Message</label>
                                        <textarea  class="form-control height-2" v-model="response.message"></textarea>
                                        <FormError :error="errors[0]" name="Message"></FormError>
                                    </div>

                                </ValidationProvider>

                                <ValidationProvider
                                    name="Status"
                                    rules="required"
                                    v-slot="{errors}"
                                    class="col-md-6 mb-5" >
                                    <label for="" class="form-label">Status:</label>
                                    <div class="buttons-type-multiselect two-btns ">
                                        <div class="item inactive">
                                            <input
                                                type="radio"
                                                class="rad"
                                                id="id-1132"
                                                :value="1"
                                                v-model="response.isActive"
                                            >
                                            <label for="id-1132">
                                                <div class="ttl">Active</div>
                                            </label>
                                            <FormError :error="errors[0]" name="Status"></FormError>
                                        </div>
                                        <div class="item active">
                                            <input
                                                type="radio"
                                                class="rad"
                                                id="id-1212"
                                                :value="0"
                                                v-model="response.isActive"
                                            >
                                            <label for="id-1212">
                                                <span class="ttl">Inactive</span>
                                            </label>
                                        </div>
                                    </div>
                                </ValidationProvider>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="btns-wrap">
                                        <a href="/master-admin/settings/preconfigured-responses" class="btn btn--outline-primary w-100 w-sm-auto">Cancel</a>
                                        <a  class="btn btn--secondary w-100 w-sm-auto" @click="validate">Save</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </ValidationObserver>
            </div>
        </div>
    </div>
</template>


<script>
import ResponsesServices from "./services/ResponsesServices";

export default {
    name: 'ResponseItem',
    props: {
        item: {
            type: Object,
            required: false
        },
    },
    data() {
        return {
            loading: true,
            isUpdate: null,
            response: {
                subject: null,
                message: null,
                isActive: null,
            }
        }
    },
    methods: {
        setData(response) {
            for (const fullKey in this.item) {
                for (const emptyKey in response) {
                    if (fullKey === emptyKey) {
                        response[fullKey] = this.item[emptyKey];
                    }
                }
            }
            this.loading = false
        },
        async saveItem() {
            try {
                await ResponsesServices.saveNewItem(this.response)
                this.$showSuccessMessage('New Response was added!')
                setTimeout(() => {
                    window.location.href = '/master-admin/settings/preconfigured-responses'
                }, 1000)
            } catch (e) {
                console.error(e)
                this.$showErrorMessage()
            }
        },
        async updateExistItem() {
            try {
                await ResponsesServices.updateItem(this.item.id, this.response)
                this.$showSuccessMessage('Response was updated!')
                setTimeout(() => {
                    window.location.href = '/master-admin/settings/preconfigured-responses'
                }, 1000)
            } catch (e) {
                console.error(e)
                this.$showErrorMessage()
            }
        },
        validate() {
            (async () => {

                const valid = await this.$refs.form.validate();
                if (!valid) {
                    this.$showErrorMessage('Info is missing')
                    return
                }
                if (this.isUpdate === false) {
                    await this.saveItem()
                } else {
                    await this.updateExistItem()
                }

            })();
        }
    },
    mounted() {
        if (!this.item) {
            this.isUpdate = false;
            this.loading = false;
        } else {
            this.isUpdate = true
            this.setData(this.response);
        }

    }
}

</script>


<style scoped>

</style>
